import {toCapitalCase} from '@s-ui/js/lib/string'

import {FormMappersFactory} from '../../form/Mappers/factory.js'
import SeoMappersFactory from '../../seo/Mappers/factory.js'
import VehiclesEntitiesFactory from '../Entities/factory.js'
import VehiclesValueObjectsFactory from '../ValueObjects/factory.js'
import FromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper from './FromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper.js'
import FromBodyTypesListRawDataToBodyTypesListValueObjectMapper from './FromBodyTypesListRawDataToBodyTypesListValueObjectMapper.js'
import FromBodyTypeUrlParamToBodyTypeParamsValueObjectMapper from './FromBodyTypeUrlParamToBodyTypeParamsValueObjectMapper.js'
import {FromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper} from './FromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper.js'
import FromDoorsSearchUrlParamToSearchCodeValueObjectMapper from './FromDoorsSearchUrlParamToSearchCodeValueObjectMapper.js'
import {FromElectricFeaturesRawDataToElectricFeaturesVOMapper} from './FromElectricFeaturesRawDataToElectricFeaturesVOMapper.js'
import FromImagesListRawDataToImagesListValueObjectMapper from './FromImagesListRawDataToImagesListValueObjectMapper.js'
import FromInfoVehicleRawDataToInfoVehicleValueObjectMapper from './FromInfoVehicleRawDataToInfoVehicleValueObjectMapper.js'
import {FromMakesJsonToMakesListVOVehiclesMapper} from './FromMakesJsonToMakesListVOVehiclesMapper.js'
import FromMakesRawDataToMakesListValueObjectMapper from './FromMakesRawDataToMakesListValueObjectMapper.js'
import FromMarketedMakeRawDataToMarketedMakeEntityMapper from './FromMarketedMakeRawDataToMarketedMakeEntityMapper.js'
import FromMarketedMakesRawDataToMarketedMakesValueObjectMapper from './FromMarketedMakesRawDataToMarketedMakesValueObjectMapper.js'
import FromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper from './FromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper.js'
import {FromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper} from './FromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper.js'
import FromModelHttpRepositoryDataToModelEntityMapper from './FromModelHttpRepositoryDataToModelEntityMapper.js'
import FromModelInfoRawDataToModelInfoValueObjectMapper from './FromModelInfoRawDataToModelInfoValueObjectMapper.js'
import FromModelsHttpRepositoryDataToModelsValueObjectMapper from './FromModelsHttpRepositoryDataToModelsValueObjectMapper.js'
import {FromModelsJsonToSubscriptionModelsListVOVehiclesMapper} from './FromModelsJsonToSubscriptionModelsListVOVehiclesMapper.js'
import FromModelsRawDataToModelsListValueObjectMapper from './FromModelsRawDataToModelsListValueObjectMapper.js'
import {FromModelVersionsRawDataToModelVersionsVOMapper} from './FromModelVersionsRawDataToModelVersionsVOMapper.js'
import {FromRawDistributorCarouselsToCarouselsInfoVOMapper} from './FromRawDistributorCarouselsToCarouselsInfoVOMapper.js'
import {FromRawFaqToFaqListValueObjectMapper} from './FromRawFaqToFaqListValueObjectMapper.js'
import {FromRawVersionsToVehicleInsightsValueObjectMapper} from './FromRawVersionsToVehicleInsightsValueObjectMapper.js'
import FromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper from './FromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper.js'
import {FromSearchToSearchVehiclesRequestValueObjectMapper} from './FromSearchToSearchVehiclesRequestValueObjectMapper.js'
import FromSearchUrlParamToSearchCodeValueObjectMapper from './FromSearchUrlParamToSearchCodeValueObjectMapper.js'
import {FromSpecsListRawDataToSpecsListValueObjectMapper} from './FromSpecsListRawDataToSpecsListValueObjectMapper.js'
import {FromSpecsParamsToSearchUrlValueObjectMapper} from './FromSpecsParamsToSearchUrlValueObjectMapper.js'
import {FromSubscriptionMakesRawDataToMakesListValueObjectMapper} from './FromSubscriptionMakesRawDataToMakesListValueObjectMapper.js'
import {FromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper} from './FromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper.js'
import {FromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper} from './FromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper.js'
import {FromVehicleCertificationRawDataToVehicleCertificationVOMapper} from './FromVehicleCertificationRawDataToVehicleCertificationVOMapper.js'
import {FromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper} from './FromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper.js'
import FromVehicleInfoRawDataToVehicleInfoValueObjectMapper from './FromVehicleInfoRawDataToVehicleInfoValueObjectMapper.js'
import {FromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper} from './FromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper.js'
import {FromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper} from './FromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper.js'
import {FromVehicleSearchJSONtoUrlVOMapper} from './FromVehicleSearchJSONtoUrlVOMapper.js'
import FromVehiclesListRawDataToVehiclesListValueObjectMapper from './FromVehiclesListRawDataToVehiclesListValueObjectMapper.js'
import FromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper from './FromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper.js'
import FromVersionInfoRawDataToVersionInfoValueObjectMapper from './FromVersionInfoRawDataToVersionInfoValueObjectMapper.js'
import FromVersionSearchUrlParamToSearchCodeValueObjectMapper from './FromVersionSearchUrlParamToSearchCodeValueObjectMapper.js'

export class VehiclesMappersFactory {
  static fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper = () =>
    new FromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper({
      relatedVehiclesListValueObjectFactory: VehiclesValueObjectsFactory.relatedVehiclesListValueObject,
      relatedVehicleValueObjectFactory: VehiclesValueObjectsFactory.relatedVehicleValueObject
    })

  static fromInfoVehicleRawDataToInfoVehicleValueObjectMapper = ({config}) =>
    new FromInfoVehicleRawDataToInfoVehicleValueObjectMapper({
      valueObject: VehiclesValueObjectsFactory.infoVehicleValueObjectFactory
    })

  static fromMakesJsonToMakesListVOVehiclesMapper = ({config}) =>
    new FromMakesJsonToMakesListVOVehiclesMapper({
      config,
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      makesListValueObjectFactory: VehiclesValueObjectsFactory.makesListValueObject
    })

  static fromModelsJsonToSubscriptionModelsListVOVehiclesMapper = ({config}) =>
    new FromModelsJsonToSubscriptionModelsListVOVehiclesMapper({
      config,
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      modelEntityFactory: VehiclesEntitiesFactory.modelEntity,
      subscriptionModelsListValueObjectFactory: VehiclesValueObjectsFactory.subscriptionModelsListValueObject,
      subscriptionModelValueObjectFactory: VehiclesValueObjectsFactory.subscriptionModelValueObject
    })

  static fromMarketedMakesRawDataToMarketedMakesValueObjectMapper = ({config}) =>
    new FromMarketedMakesRawDataToMarketedMakesValueObjectMapper({
      mapper: VehiclesMappersFactory.fromMarketedMakeRawDataToMarketedMakeEntityMapper({
        config
      }),
      valueObject: VehiclesValueObjectsFactory.marketedMakesValueObject
    })

  static fromMarketedMakeRawDataToMarketedMakeEntityMapper = ({config}) =>
    new FromMarketedMakeRawDataToMarketedMakeEntityMapper({
      config,
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      toCapitalCase
    })

  static fromMakesRawDataToMakesListValueObjectMapper = () =>
    new FromMakesRawDataToMakesListValueObjectMapper({
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      valueObject: VehiclesValueObjectsFactory.makesListValueObject
    })

  static fromRawVersionsToVehicleInsightsValueObjectMapper = ({config}) =>
    new FromRawVersionsToVehicleInsightsValueObjectMapper({
      config,
      vehicleInsightsValueObjectFactory: VehiclesValueObjectsFactory.vehicleInsightsValueObject
    })

  // constructor({config, faqValueObjectFactory, faqsValueObjectFactory}) {
  static fromRawFaqToFaqListValueObjectMapper = ({config}) =>
    new FromRawFaqToFaqListValueObjectMapper({
      config,
      faqValueObjectFactory: VehiclesValueObjectsFactory.faqValueObjectFactory,
      faqsValueObjectFactory: VehiclesValueObjectsFactory.faqsValueObjectFactory
    })

  static fromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper = ({config}) =>
    new FromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper({
      config,
      modelDetailContentValueObjectFactory: VehiclesValueObjectsFactory.modelDetailContentValueObject,
      faqStructuredDataSeoMapper: SeoMappersFactory.faqStructuredDataSeoMapper({config}),
      fromRawVersionsToVehicleInsightsValueObjectMapper:
        VehiclesMappersFactory.fromRawVersionsToVehicleInsightsValueObjectMapper({config}),
      fromRawFaqToFaqListValueObjectMapper: VehiclesMappersFactory.fromRawFaqToFaqListValueObjectMapper({
        config
      })
    })

  static fromModelsRawDataToModelsListValueObjectMapper = () =>
    new FromModelsRawDataToModelsListValueObjectMapper({
      modelEntityFactory: VehiclesEntitiesFactory.modelEntity,
      valueObject: VehiclesValueObjectsFactory.modelsListValueObject
    })

  static fromModelVersionsRawDataToModelVersionsVOMapper = ({config}) =>
    new FromModelVersionsRawDataToModelVersionsVOMapper({
      config,
      fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper:
        VehiclesMappersFactory.fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper(),
      fromRawVersionsToVehicleInsightsValueObjectMapper:
        VehiclesMappersFactory.fromRawVersionsToVehicleInsightsValueObjectMapper({config}),
      fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper:
        VehiclesMappersFactory.fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper({config}),
      modelVersionsValueObjectFactory: VehiclesValueObjectsFactory.modelVersionsValueObjectFactory,
      offerPriceValueObjectFactory: VehiclesValueObjectsFactory.offerPriceValueObject
    })

  static fromModelsHttpRepositoryDataToModelsValueObjectMapper = ({config}) =>
    new FromModelsHttpRepositoryDataToModelsValueObjectMapper({
      mapper: VehiclesMappersFactory.fromModelHttpRepositoryDataToModelEntityMapper({
        config
      }),
      valueObject: VehiclesValueObjectsFactory.modelsGroupedByBodyTypeDoorsValueObject
    })

  static fromModelHttpRepositoryDataToModelEntityMapper = ({config}) =>
    new FromModelHttpRepositoryDataToModelEntityMapper({
      config,
      modelEntityFactory: VehiclesEntitiesFactory.modelEntity,
      toCapitalCase
    })

  static fromSearchUrlParamToSearchCodeValueObjectMapper = ({config}) =>
    new FromSearchUrlParamToSearchCodeValueObjectMapper({
      config,
      valueObject: VehiclesValueObjectsFactory.searchCodeValueObject
    })

  static fromDoorsSearchUrlParamToSearchCodeValueObjectMapper = ({config}) =>
    new FromDoorsSearchUrlParamToSearchCodeValueObjectMapper({
      config,
      valueObject: VehiclesValueObjectsFactory.searchCodeValueObject
    })

  static fromVersionSearchUrlParamToSearchCodeValueObjectMapper = ({config}) =>
    new FromVersionSearchUrlParamToSearchCodeValueObjectMapper({
      config,
      valueObject: VehiclesValueObjectsFactory.searchCodeValueObject
    })

  static fromBodyTypeUrlParamToBodyTypeParamsValueObjectMapper = ({config}) =>
    new FromBodyTypeUrlParamToBodyTypeParamsValueObjectMapper({
      config,
      valueObject: VehiclesValueObjectsFactory.bodyTypeParamsValueObject
    })

  static fromModelInfoRawDataToModelInfoValueObjectMapper = ({config}) =>
    new FromModelInfoRawDataToModelInfoValueObjectMapper({
      fromBodyTypesListRawDataToBodyTypesListValueObjectMapper:
        VehiclesMappersFactory.fromBodyTypesListRawDataToBodyTypesListValueObjectMapper({config}),
      fromVehiclesListRawDataToVehiclesListValueObjectMapper:
        VehiclesMappersFactory.fromVehiclesListRawDataToVehiclesListValueObjectMapper({config}),
      fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper:
        VehiclesMappersFactory.fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper({config}),
      fromImagesListRawDataToImagesListValueObjectMapper:
        VehiclesMappersFactory.fromImagesListRawDataToImagesListValueObjectMapper({config}),
      valueObject: VehiclesValueObjectsFactory.modelInfoValueObject
    })

  static fromBodyTypesListRawDataToBodyTypesListValueObjectMapper = ({config}) =>
    new FromBodyTypesListRawDataToBodyTypesListValueObjectMapper({
      config,
      bodyTypeValueObject: VehiclesValueObjectsFactory.bodyTypeValueObject,
      bodyTypesListValueObject: VehiclesValueObjectsFactory.bodyTypesListValueObject
    })

  static fromVehiclesListRawDataToVehiclesListValueObjectMapper = ({config}) =>
    new FromVehiclesListRawDataToVehiclesListValueObjectMapper({
      config,
      entity: VehiclesEntitiesFactory.vehicleEntity,
      valueObject: VehiclesValueObjectsFactory.vehiclesListValueObject
    })

  static fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper = ({config}) =>
    new FromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper({
      config,
      vehicleEntityFactory: VehiclesEntitiesFactory.vehicleEntity,
      offerPriceValueObjectFactory: VehiclesValueObjectsFactory.offerPriceValueObject,
      vehicleOfferValueObjectFactory: VehiclesValueObjectsFactory.vehicleOfferValueObject,
      vehicleOffersListValueObjectFactory: VehiclesValueObjectsFactory.vehicleOffersListValueObject
    })

  static fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper = ({config}) =>
    new FromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper({
      config,
      relatedVehicleValueObject: VehiclesValueObjectsFactory.relatedVehicleValueObject,
      relatedVehiclesListValueObject: VehiclesValueObjectsFactory.relatedVehiclesListValueObject
    })

  static fromImagesListRawDataToImagesListValueObjectMapper = ({config}) =>
    new FromImagesListRawDataToImagesListValueObjectMapper({
      config,
      imagesListValueObject: VehiclesValueObjectsFactory.imagesListValueObject,
      imageValueObject: VehiclesValueObjectsFactory.imageValueObject
    })

  static fromVersionInfoRawDataToVersionInfoValueObjectMapper = ({config}) =>
    new FromVersionInfoRawDataToVersionInfoValueObjectMapper({
      fromImagesListRawDataToImagesListValueObjectMapper:
        VehiclesMappersFactory.fromImagesListRawDataToImagesListValueObjectMapper({config}),
      fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper:
        VehiclesMappersFactory.fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper({config}),
      fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper:
        VehiclesMappersFactory.fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper({config}),
      versionSpecificationsValueObjectFactory: VehiclesValueObjectsFactory.versionSpecificationsValueObject,
      versionInfoValueObjectFactory: VehiclesValueObjectsFactory.versionInfoValueObject
    })

  static fromVehicleInfoRawDataToVehicleInfoValueObjectMapper = ({config}) =>
    new FromVehicleInfoRawDataToVehicleInfoValueObjectMapper({
      fromImagesListRawDataToImagesListValueObjectMapper:
        VehiclesMappersFactory.fromImagesListRawDataToImagesListValueObjectMapper({config}),
      fromSearchUrlParamToSearchCodeValueObjectMapper:
        VehiclesMappersFactory.fromSearchUrlParamToSearchCodeValueObjectMapper({
          config
        }),
      electricFeaturesMapper: VehiclesMappersFactory.fromElectricFeaturesRawDataToElectricFeaturesVOMapper({config}),
      versionSpecificationsValueObjectFactory: VehiclesValueObjectsFactory.versionSpecificationsValueObject,
      groupedVersionSpecificationsValueObjectFactory:
        VehiclesValueObjectsFactory.groupedVersionSpecificationsValueObject,
      descriptionItemValueObjectFactory: VehiclesValueObjectsFactory.descriptionItemValueObject,
      vehicleInfoValueObjectFactory: VehiclesValueObjectsFactory.vehicleInfoValueObject,
      equipmentValueObjectFactory: VehiclesValueObjectsFactory.equipmentValueObject,
      equipmentSectionValueObjectFactory: VehiclesValueObjectsFactory.equipmentSectionValueObject
    })

  static fromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper = ({config}) =>
    new FromVehicleVersionDetailRawDataToVehicleInfoValueObjectMapper({
      fromImagesListRawDataToImagesListValueObjectMapper:
        VehiclesMappersFactory.fromImagesListRawDataToImagesListValueObjectMapper({config}),
      fromSearchUrlParamToSearchCodeValueObjectMapper:
        VehiclesMappersFactory.fromSearchUrlParamToSearchCodeValueObjectMapper({
          config
        }),
      electricFeaturesMapper: VehiclesMappersFactory.fromElectricFeaturesRawDataToElectricFeaturesVOMapper({config}),
      versionSpecificationsValueObjectFactory: VehiclesValueObjectsFactory.versionSpecificationsValueObject,
      groupedVersionSpecificationsValueObjectFactory:
        VehiclesValueObjectsFactory.groupedVersionSpecificationsValueObject,
      descriptionItemValueObjectFactory: VehiclesValueObjectsFactory.descriptionItemValueObject,
      vehicleInfoValueObjectFactory: VehiclesValueObjectsFactory.vehicleInfoValueObject,
      equipmentValueObjectFactory: VehiclesValueObjectsFactory.equipmentValueObject,
      equipmentSectionValueObjectFactory: VehiclesValueObjectsFactory.equipmentSectionValueObject
    })

  static fromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper = ({config}) =>
    new FromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper({
      config,
      vehicleInfoValueObjectFactory: VehiclesValueObjectsFactory.vehicleInfoValueObject
    })

  static fromElectricFeaturesRawDataToElectricFeaturesVOMapper = ({config}) =>
    new FromElectricFeaturesRawDataToElectricFeaturesVOMapper({
      config,
      valueObject: VehiclesValueObjectsFactory.electricFeaturesValueObject
    })

  static fromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper = ({config}) =>
    new FromMarketedVersionsListRawDataToMarketedVersionsListValueObjectMapper({
      config,
      marketedVersionsListValueObject: VehiclesValueObjectsFactory.marketedVersionsListValueObject,
      marketedVersionValueObject: VehiclesValueObjectsFactory.marketedVersionValueObject
    })

  static fromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper = ({config}) =>
    new FromAvailableYearsRawDataToAvailableMarketedYearsValueObjectMapper({
      config,
      marketedYearValueObject: VehiclesValueObjectsFactory.marketedYearValueObject,
      availableMarketedYearsValueObject: VehiclesValueObjectsFactory.availableMarketedYearsValueObject
    })

  static fromRawDistributorCarouselsToCarouselsInfoVOMapper = ({config}) =>
    new FromRawDistributorCarouselsToCarouselsInfoVOMapper({
      config,
      carouselInfoValueObject: VehiclesValueObjectsFactory.carouselInfoValueObject,
      carouselsInfoValueObject: VehiclesValueObjectsFactory.carouselsInfoValueObject,
      latestModelValueObject: VehiclesValueObjectsFactory.latestModelValueObject
    })

  static fromSpecsParamsToSearchUrlValueObjectMapper = ({config}) =>
    new FromSpecsParamsToSearchUrlValueObjectMapper({
      config,
      fromFormParamsToSearchUrlFormValueObjectMapper:
        FormMappersFactory.fromFormParamsToSearchUrlFormValueObjectMapper()
    })

  static fromSpecsListRawDataToSpecsListValueObjectMapper = ({config}) =>
    new FromSpecsListRawDataToSpecsListValueObjectMapper({
      config,
      specsListValueObjectFactory: VehiclesValueObjectsFactory.specsListValueObject,
      specsValueObjectFactory: VehiclesValueObjectsFactory.specsValueObject
    })

  static fromVehicleSearchJSONtoUrlVOMapper = ({config}) =>
    new FromVehicleSearchJSONtoUrlVOMapper({
      config
    })

  static fromSearchToSearchVehiclesRequestValueObjectMapper = ({config}) =>
    new FromSearchToSearchVehiclesRequestValueObjectMapper({
      config,
      searchVehiclesRequestValueObject: VehiclesValueObjectsFactory.searchVehiclesRequestValueObject
    })

  static fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper = ({config}) =>
    new FromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper({
      config,
      vehicleHistoryValueObjectFactory: VehiclesValueObjectsFactory.vehicleHistoryValueObject
    })

  static fromVehicleCertificationRawDataToVehicleCertificationVOMapper = ({config}) =>
    new FromVehicleCertificationRawDataToVehicleCertificationVOMapper({
      config,
      fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper:
        VehiclesMappersFactory.fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper({
          config
        }),
      vehicleCertificationValueObject: VehiclesValueObjectsFactory.vehicleCertificationValueObject
    })

  static fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper = ({config}) =>
    new FromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper({
      config,
      vehicleCertificationFeatureValueObject: VehiclesValueObjectsFactory.vehicleCertificationFeatureValueObject,
      vehicleCertificationFeaturesListValueObject:
        VehiclesValueObjectsFactory.vehicleCertificationFeaturesListValueObject
    })

  static fromSubscriptionMakesRawDataToMakesListValueObjectMapper = ({config}) =>
    new FromSubscriptionMakesRawDataToMakesListValueObjectMapper({
      config,
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      makesListValueObjectFactory: VehiclesValueObjectsFactory.makesListValueObject
    })

  static fromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper = ({config}) =>
    new FromSubscriptionModelsRawDataToSubscriptionModelsListValueObjectMapper({
      config,
      makeEntityFactory: VehiclesEntitiesFactory.makeEntity,
      modelEntityFactory: VehiclesEntitiesFactory.modelEntity,
      subscriptionModelValueObjectFactory: VehiclesValueObjectsFactory.subscriptionModelValueObject,
      subscriptionModelsListValueObjectFactory: VehiclesValueObjectsFactory.subscriptionModelsListValueObject
    })
}
